import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface FuneralState {
  funeralHomes: Array<any>;
}

const state = (): FuneralState => ({
  funeralHomes: [],
});

const mutations = {
  STORE_FUNERAL_HOMES(
    state: FuneralState,
    funeralHomes: FuneralState["funeralHomes"]
  ) {
    state.funeralHomes = funeralHomes;
  },
};

const getters = {
  getFuneralHomes(state: FuneralState): FuneralState["funeralHomes"] {
    return state.funeralHomes;
  },
};

const actions = {
  async getFuneralHomes({ commit }: { commit: Commit }) {
    const endpoint = "/funeral-homes";

    const res = await http.get(endpoint);

    commit("STORE_FUNERAL_HOMES", res.data.funeralHomes);

    return res.data;
  },
  async createFuneralApplication({ commit }: { commit: Commit }, data: any) {
    const endpoint = "/application/funeral";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  // async register(_ctx: any, data: any) {
  //   const endpoint = `${userService}/signup`;

  //   const res = await http.post(endpoint, data);

  //   return res;
  // },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
